module.exports = __webpack_public_path__ + "static/media/Euchre.0bd882d4.jpg";